import type { IconProps } from "../types";

export const FilePen = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M12.659 22H20V8L14 2H4V13.34" />
    <path d="M14 2v6h6" />
    <path d="M10.378 12.622 13.5 15.744 7.5 21.744l-3.5 1 1-3.5z" />
  </svg>
);
